package com.essntl.features.itinerary.ui.edit_itinerary

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

sealed interface EditItineraryNavigation {

    data object NavigateBack : EditItineraryNavigation

    data class EditItineraryService(
        val itineraryService: ItineraryServiceModel,
    ) : EditItineraryNavigation

    data class GetItinerary(
        val itineraryService: ItineraryServiceModel,
    ) : EditItineraryNavigation

    data class AddItineraryTask(
        val itineraryId: ItineraryModel,
        val proposalId: String,
    ) : EditItineraryNavigation

    data class EditTask(
        val taskId: String,
    ) : EditItineraryNavigation

    data object AddClient : EditItineraryNavigation

    data object SelectClient : EditItineraryNavigation

    data class EditClient(val client: ClientModel) : EditItineraryNavigation

    data class ChangeTravelAgent(val proposal: ProposalModel) : EditItineraryNavigation

    data class EditTravelAgent(val proposal: ProposalModel) : EditItineraryNavigation

    data class SendMessage(
        val itineraryServices: List<ItineraryServiceModel>,
        val type: MessageSendType,
    ) : EditItineraryNavigation

    data class EditInvoice(
        val invoiceId: String,
        val proposalId: String,
        val itineraryId: String,
    ) : EditItineraryNavigation

    data class EditProposal(val proposalId: String) : EditItineraryNavigation
}